import AppContainer from './src/containers/App/appContainer';
import React, { useEffect, useState } from 'react';
import {createRoot} from 'react-dom/client';
import { Provider, useDispatch } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import configureStore from 'store';
import setupInterceptors from './src/interceptor';
import './index.css';
import { getAuthKeys } from './src/actions/authActions';

if (!String.prototype.startsWith) {
    String.prototype.startsWith = (searchString, position) => {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}

(() => {
    let isJiraEnabled = process.env.REACT_APP_JIRA_ISSUE_COLLECTOR_ENABLED;
    if (isJiraEnabled === 'true') {
        let src = process.env.REACT_APP_JIRA_ISSUE_COLLECTOR_URL;
        document.write('<script src="' + src + '"><\/script>');
    }
})();

// Configure Store
const store = configureStore({}, {});
// Configure Interceptor

const AppBootstrap = () => {
  const dispatch = useDispatch();
  const [ready, setIsReady] = useState(false);
  useEffect(() => {
    getAuthKeys(dispatch, (response) => {
      if (response) {
        setupInterceptors(store);
        setIsReady(true);
      }
    });
  }, [dispatch]);

  if (!ready) {
    return <></>;
  }

  return <AppContainer />;
};
// Configure Provider
createRoot(document.getElementById('root')).render(<Provider store={store}>
    <BrowserRouter>
        <AppBootstrap />
    </BrowserRouter>
</Provider>);
